import React from "react";
import { Container, Nav } from "react-bootstrap";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Header = React.memo(() => {
    return (
        <Container fluid className="header align-items-center justify-content-between">
            <div className="d-flex align-items-center">
                <Nav.Link href="/" style={{ padding: 0 }}><img src="/favicon-32x32.png" alt="SEC logo" /></Nav.Link>
                <Nav.Link href="/" style={{ paddingRight: 0 }}><h1>Space Environment Canada Data Portal</h1></Nav.Link>
            </div>
            <a href="https://space-environment.ca">Back to Space Environment Canada&nbsp;&nbsp;&nbsp;<FontAwesomeIcon size="sm" icon={faSignOutAlt} /></a>
        </Container>
    );
});

export default Header;